import 'angular:locale/data:tr';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "tr";
